export const probeHex = (property) => {
  const probe = document.createElement("span");
  probe.style.color = `var(${property})`;
  document.body.appendChild(probe);
  const colour = getComputedStyle(probe).color;
  probe.remove();

  const context = document.createElement("canvas").getContext("2d");
  context.fillStyle = colour;
  context.fillRect(0, 0, 1, 1);
  const [red, green, blue] = context.getImageData(0, 0, 1, 1).data;

  return "#" + [red, green, blue].map((channel) => channel.toString(16).padStart(2, "0")).join("");
};

export const ComputedColour = {
  mounted() {
    this.fill();
  },

  updated() {
    requestAnimationFrame(() => this.fill());
  },

  fill() {
    if (!this.el.dataset.hex) this.el.value = probeHex(this.el.dataset.computedColor);
  },
};
